// Firestore + callable glue for the Forms screens. Pure derivations live in
// formsView.js; this module is the only Forms code that imports firebase.
import {
  collection, doc, query, where, orderBy, onSnapshot, deleteDoc,
} from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import { db, functions } from './firebase.js'

const docsOf = (snap) => snap.docs.map((d) => ({ id: d.id, ...d.data() }))

export function watchForms(cb) {
  const q = query(collection(db, 'forms'), orderBy('name', 'asc'))
  return onSnapshot(q, (snap) => cb(docsOf(snap)))
}

export function watchForm(id, cb) {
  return onSnapshot(doc(db, 'forms', id), (snap) => cb(snap.exists() ? { id: snap.id, ...snap.data() } : null))
}

export function watchSubmissions(formId, cb) {
  const q = query(
    collection(db, 'formSubmissions'),
    where('formId', '==', formId),
    orderBy('createdAt', 'desc'),
  )
  return onSnapshot(q, (snap) => cb(docsOf(snap)))
}

export function watchSubmission(id, cb) {
  return onSnapshot(doc(db, 'formSubmissions', id), (snap) => cb(snap.exists() ? { id: snap.id, ...snap.data() } : null))
}

export function watchFormStats(formId, cb) {
  const q = query(
    collection(db, 'formStats'),
    where('formId', '==', formId),
    orderBy('date', 'asc'),
  )
  return onSnapshot(q, (snap) => cb(docsOf(snap)))
}

export function deleteSubmission(id) {
  return deleteDoc(doc(db, 'formSubmissions', id))
}

export async function callPromote(submissionId, action) {
  const fn = httpsCallable(functions, 'promoteSubmission')
  const res = await fn({ submissionId, action })
  return res.data
}
